import { Routes } from '@angular/router';
import {
  getManageSimAnalyticsConfig,
  ManageSimConfigService,
  manageSimRoutes,
} from '@rogers/self-serve-wireless/manage-sim';
import { getWirelessDeeplinkGuard } from '@rci/self-serve-fido/guard/routing.guards';
import { SubscriberDeeplinkGuard } from '@rci/self-serve-fido/guard/subscriber-deeplink.guard';
import { provideAnalyticsConfiguration, provideSelfServeAnalyticsService } from '@rci/self-serve-fido/core/analytics';
import { MYACCOUNT_APPID } from '@rci/self-serve-fido/app.constant';
import { ManageSimAppConfigService } from './manage-sim-app.config.service';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';
import { ContactDetailFacadeService } from '@rci/self-serve-fido/state/contact-detail/contact-detail-facade.service';

export const manageSimAppRoutes: Routes = [
  {
    path: 'manage-sim',
    children: manageSimRoutes,
    canActivate: [...getWirelessDeeplinkGuard('manage-sim'), SubscriberDeeplinkGuard],
    providers: [
      provideAnalyticsConfiguration(getManageSimAnalyticsConfig(MYACCOUNT_APPID)),
      ...provideSelfServeAnalyticsService(),
      {
        provide: ManageSimConfigService,
        useClass: ManageSimAppConfigService,
        deps: [BreadcrumbsService, ContactDetailFacadeService],
      },
    ],
  },
];
